import { Grid } from '@material-ui/core';
import React from 'react';
import Card from '../../components/Card/Card.component';
import { ICustomer } from '../../models/ICustomers';
import Label from '../Label/Label.component';

interface Props {
    data: ICustomer
}

export default function CustomerInfo({
    data
}: Props) {
    return (
        <Card>
            <Grid container>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Name:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.firstName} {data?.lastName}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Email:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.email}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Referral Code:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.referralCode || "Not assigned"}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Referral Link:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.referralLink || "Not assigned"}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Active Referrals:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.activeReferralCount || 0}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Total Referral Signups:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.totalReferralSignups || 0}
                    </Label>
                </Grid>
            </Grid>
        </Card>
    )
}
